<template>
  <div
    v-clickoutside="hideTooltip"
    class="skincare-finder__answer"
  >
    <div class="skincare-finder__answer__container">
      <input
        :id="answer.id"
        class="checkbox"
        name="answer"
        :type="isMultipleSelection ? 'checkbox':'radio'"
        :value="answer.id"
        @change="check($event)"
      >
      <label
        :id="`label--${answer.id}`"
        :for="answer.id"
        v-text="answer.label"
      />
      <div
        v-if="answer.tooltipCopyText.length > 0"
        class="skincare-finder__answer__tooltip-trigger"
      >
        <button
          :aria-controls="`info--${answer.id}`"
          :aria-expanded="displayingTooltip ? 'true' : 'false'"
          :aria-label="displayingTooltip ? tooltipCloseAlt:tooltipOpenAlt"
          :aria-labelledby="`label--${answer.id}`"
          @click="toggleTooltip(answer.id)"
        >
          <svg
            v-if="!displayingTooltip || !smallScreen"
            class="icon icon-info"
            viewBox="0 0 100 100"
          >
            <use xlink:href="#info-outline" />
          </svg>
          <svg
            v-if="displayingTooltip && smallScreen"
            class="icon icon-info"
            viewBox="0 0 100 100"
          >
            <use xlink:href="#close-circle" />
          </svg>
        </button>
      </div>
    </div>
    <div
      v-show="displayingTooltip"
      :id="`info--${answer.id}`"
      class="skincare-finder__answer__tooltip-container"
    >
      <svg
        class="icon icon-info"
        viewBox="0 0 100 100"
      >
        <use xlink:href="#info-filled" />
      </svg>
      <div class="skincare-finder__answer__tooltip-container--text">
        {{ answer.tooltipCopyText }}
      </div>
    </div>
  </div>
</template>

<script>
  import { clickoutside } from '@Foundation/directives/clickoutside/clickoutside';

  export default {
    name: 'SkincareFinderAnswer',
    directives: {
      clickoutside
    },
    props: {
      answer: { type: Object, required: true },
      isMultipleSelection: { type: Boolean, required: true },
      tooltipCloseAlt: { type: String, required: false, default: 'Close Info' },
      tooltipOpenAlt: { type: String, required: false, default: 'Open Info' }
    },
    data() {
      return {
        displayingTooltip: false,
        smallScreen: !window.matchMedia('(min-width: 1025px)').matches
      };
    },
    methods: {
      hideTooltip() {
        this.displayingTooltip = false;
      },
      toggleTooltip() {
        if (this.displayingTooltip) {
          this.hideTooltip();
          return;
        }
        this.displayingTooltip = true;
      },
      check(event) {
        this.$parent.$emit(
          'checked-answer',
          {
            id: this.answer.id,
            event: event
          }
        );
      }
    }
  };
</script>
